{
  "AGENT_MGMT": {
    "HEADER": "الوكلاء",
    "HEADER_BTN_TXT": "إضافة وكيل",
    "LOADING": "جار جلب قائمة الوكلاء",
    "DESCRIPTION": "الوكيل هو عضو في فريق دعم العملاء الذي يمكنه عرض رسائل المستخدم والرد عليها. القائمة أدناه تظهر جميع الوكلاء في حسابك.",
    "LEARN_MORE": "تعرف على أدوار المستخدم",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "المدير",
      "AGENT": "وكيل الدعم"
    },
    "TABS": {
      "ACTIVE": "نشط",
      "DEACTIVATED": "معطّل"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "فصل الهاتف",
      "API": {
        "SUCCESS_MESSAGE": "تم فصل هاتف الوكيل بنجاح",
        "ERROR_MESSAGE": "تعذّر فصل هاتف الوكيل، يرجى المحاولة مرة أخرى لاحقًا"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "إعادة التنشيط",
      "API": {
        "SUCCESS_MESSAGE": "تمت إعادة تنشيط الوكيل بنجاح",
        "ERROR_MESSAGE": "تعذّر إعادة تنشيط الوكيل، يرجى المحاولة مرة أخرى لاحقًا"
      },
      "CONFIRM": {
        "TITLE": "تأكيد إعادة التنشيط",
        "MESSAGE": "هل أنت متأكد أنك تريد إعادة تنشيط ",
        "YES": "نعم، أعد التنشيط ",
        "NO": "لا، إلغاء "
      }
    },
    "LIST": {
      "404": "لا يوجد وكلاء دعم مرتبطين بهذا الحساب",
      "TITLE": "إدارة وكلاء الدعم في فريقك",
      "DESC": "يمكنك إضافة/إزالة وكلاء الدعم الفني في فريقك.",
      "NAME": "الاسم",
      "EMAIL": "البريد الإلكتروني",
      "STATUS": "الحالة",
      "ACTIONS": "الإجراءات",
      "VERIFIED": "تم التحقق",
      "VERIFICATION_PENDING": "بانتظار التحقق",
      "API_ALLOWED": "الوصول إلى API مسموح",
      "AVAILABLE_CUSTOM_ROLE": "صلاحيات الدور المخصص المتاحة"
    },
    "ADD": {
      "TITLE": "إضافة وكيل دعم فني إلى فريقك",
      "DESC": "يمكنك إضافة وكلاء الدعم للرد على الرسائل في صندوق الوارد المشترك الخاص بفريقك.",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "FORM": {
        "NAME": {
          "LABEL": "اسم الوكيل",
          "PLACEHOLDER": "الرجاء إدخال اسم الوكيل"
        },
        "AGENT_TYPE": {
          "LABEL": "دور الوكيل",
          "PLACEHOLDER": "الرجاء تحديد الدور",
          "ERROR": "دور الوكيل مطلوب"
        },
        "EMAIL": {
          "LABEL": "عنوان البريد الإلكتروني",
          "PLACEHOLDER": "الرجاء إدخال عنوان البريد الإلكتروني للوكيل"
        },
        "SUBMIT": "إضافة وكيل"
      },
      "API": {
        "SUCCESS_MESSAGE": "تم إضافة الوكيل بنجاح",
        "EXIST_MESSAGE": "عنوان البريد الإلكتروني للوكيل مستخدم مسبقاً، الرجاء إضافة عنوان آخر",
        "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "API": {
        "SUCCESS_MESSAGE": "تم حذف حساب الوكيل بنجاح",
        "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
      },
      "CONFIRM": {
        "TITLE": "تأكيد الحذف",
        "MESSAGE": "هل أنت متأكد من الحذف ",
        "DESCRIPTION": "سيتم تسجيل خروج الوكيل فورًا، وإزالته من جميع الفرق وصناديق الوارد، ولن يتمكن بعد ذلك من الوصول إلى هذا الحساب.",
        "YES": "نعم، احذف ",
        "NO": "لا، احتفظ "
      }
    },
    "EDIT": {
      "TITLE": "تعديل الوكيل",
      "FORM": {
        "NAME": {
          "LABEL": "اسم الوكيل",
          "PLACEHOLDER": "الرجاء إدخال اسم الوكيل"
        },
        "AGENT_TYPE": {
          "LABEL": "دور الوكيل",
          "PLACEHOLDER": "الرجاء تحديد الدور",
          "ERROR": "دور الوكيل مطلوب"
        },
        "EMAIL": {
          "LABEL": "عنوان البريد الإلكتروني",
          "PLACEHOLDER": "الرجاء إدخال عنوان البريد الإلكتروني للوكيل"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "التوفر",
          "PLACEHOLDER": "الرجاء تحديد حالة التوفر",
          "ERROR": "حالة التوفر مطلوبة"
        },
        "API_ACCESS": {
          "LABEL": "السماح بالوصول إلى API",
          "HELP": "الوصول إلى API متوقف افتراضيًا. تفعيله يتيح استخدام مفتاح API الشخصي الخاص بهذا الوكيل، في كل حساب ينتمي إليه. لا يؤثر ذلك على تسجيل الدخول إلى لوحة التحكم."
        },
        "SUBMIT": "تعديل الوكيل"
      },
      "BUTTON_TEXT": "تعديل",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "API": {
        "SUCCESS_MESSAGE": "تم تحديث حساب الوكيل بنجاح",
        "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "إعادة تعيين كلمة المرور",
        "ADMIN_SUCCESS_MESSAGE": "تم إرسال بريد إلكتروني مع تعليمات إعادة تعيين كلمة المرور للوكيل",
        "SUCCESS_MESSAGE": "إعادة تعيين كلمة مرور حساب الوكيل بنجاح",
        "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "لم يتم العثور على النتائج."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "لا شيء",
      "TITLE": {
        "AGENT": "اختر وكيل",
        "TEAM": "اختر فريق"
      },
      "LIST": {
        "NONE": "لا شيء"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "لم يتم العثور على وكلاء",
          "TEAM": "لم يتم العثور على فريق"
        },
        "PLACEHOLDER": {
          "AGENT": "البحث عن وكلاء",
          "TEAM": "البحث عن فريق",
          "INPUT": "البحث عن وكلاء"
        }
      }
    }
  }
}
